import { getBootstrapData } from '@experience/core-hostapp-share-lib';

import { client } from './generated/api/client.gen';

export { client } from './generated/api/client.gen';

/**
 * Конфигурирует общий клиент API, сгенерированный openapi-ts.
 */
export const initApiClient = () => {
  const { userId, isUnderImpersonalization } = getBootstrapData();
  // никогда не берем значение из runtime-конфигурации, всегда берется текущий домен,
  // если нужно использовать другой домен, то нужно прописать его явно в .env.production
  const apiUrl = import.meta.env.VITE_API_URL as string | undefined;
  const config = client.getConfig();
  let baseUrl = config.baseUrl;

  if (apiUrl && config.baseUrl !== apiUrl) {
    baseUrl = apiUrl;
  } else if (!apiUrl) {
    baseUrl = '';
  }

  const newHeaders: Record<string, string> = {};

  if (userId !== null && isUnderImpersonalization) {
    newHeaders['Impersonate'] = String(userId);
  }

  client.setConfig({ baseUrl, headers: newHeaders });

  return client;
};
